import type { NamespaceSchema } from './types';

export const hostSettings: NamespaceSchema = {
  namespace: 'host-settings',
  label: 'Vendor / host',
  description: 'Defaults for vendor signups, commission, and payouts. Commission is DEDUCTED from what a crew earns — distinct from the platform fee under Pricing, which is added on top of the customer\'s price. Both apply to the same booking without double-charging.',
  sections: [
    {
      label: 'Onboarding',
      fields: [
        { kind: 'select', key: 'register_role', label: 'Default role on signup', default: 'customer', options: [
          { value: 'customer', label: 'Customer' },
          { value: 'vendor', label: 'Vendor (must apply)' },
        ] },
        { kind: 'boolean', key: 'auto_approve_vendors', label: 'Auto-approve vendor applications', default: false },
      ],
    },
    {
      label: 'Commission',
      fields: [
        { kind: 'select', key: 'commission_type', label: 'Commission type', default: 'percent', options: [
          { value: 'percent', label: 'Percent of booking subtotal' },
          { value: 'fixed', label: 'Fixed amount per booking' },
        ] },
        { kind: 'number', key: 'commission_amount', label: 'Commission taken from the crew (PERCENT: 15 = 15%)', default: 15, min: 0, max: 100 },
      ],
    },
    {
      label: 'Payouts',
      fields: [
        { kind: 'multiselect', key: 'payouts_eligible_booking_statuses', label: 'Booking statuses eligible for payout', default: ['completed'], options: [
          { value: 'pending', label: 'Pending' },
          { value: 'confirmed', label: 'Confirmed' },
          { value: 'completed', label: 'Completed' },
        ] },
        { kind: 'multiselect', key: 'payouts_methods_provider', label: 'Allowed payout methods', default: ['bank_transfer'], options: [
          { value: 'bank_transfer', label: 'Bank transfer' },
          { value: 'paypal', label: 'PayPal' },
          { value: 'wise', label: 'Wise' },
          { value: 'stripe_connect', label: 'Stripe Connect' },
        ] },
        { kind: 'number', key: 'payouts_min_amount', label: 'Minimum payout amount (primary currency)', default: 50, min: 0 },
        { kind: 'select', key: 'payouts_cadence', label: 'Cadence', default: 'monthly', options: [
          { value: 'weekly', label: 'Weekly' },
          { value: 'biweekly', label: 'Biweekly' },
          { value: 'monthly', label: 'Monthly' },
          { value: 'manual', label: 'Manual approval only' },
        ] },
      ],
    },
  ],
};
